import { useApolloClient } from "@apollo/client";
import Button from "@mostrans/web-components/components/base/Button";
import FormGroup from "@mostrans/web-components/components/base/FormGroup";
import Input from "@mostrans/web-components/components/base/Input";
import { FullScreenLoading } from "@mostrans/web-components/components/base/Loading";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
} from "@mui/material";
import React, { useState } from "react";
import { TagsInput } from "react-tag-input-component";
import { ToastContainer, toast } from "react-toastify";
import { CreateMasterClinic } from "../../../GQL/mutations";
import { constructEntryClinic } from "./CreateHelpers";


function ModalCreateClinic(props) {
  const [modalCreateClinic, setModalCreateClinic] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { errInput, setErrInput, fetchMasterClinic } = props;
  const client = useApolloClient();
  const [inputClinic, setInputClinic] = useState({
    clinic_name: "",
    clinic_branch: "",
    clinic_telp: "",
    clinic_address: "",
    clinic_email: ""
  });
  const handleOpenModalCreateClinic = () => {
    setModalCreateClinic(true);
    clearValueInput();
  };

  const handleCloseModalCreateClinic = () => {
    setModalCreateClinic(false);
    setErrInput(false);
    clearValueInput();
  };

  const clearValueInput = () => {
    setInputClinic({
      clinic_name: "",
      clinic_branch: "",
      clinic_telp: "",
      clinic_address: "",
      clinic_email: []
    });
  };

  const submitClinic = async () => {
    // const paramCreateClinic = {
    //   clinic_name: inputClinic.clinic_name,
    //   clinic_branch: inputClinic.clinic_branch,
    //   clinic_address: inputClinic.clinic_address,
    //   telp_number: inputClinic.clinic_telp,
    //   clinic_email: inputClinic.clinic_email
    // };
    const paramCreateClinic = constructEntryClinic(inputClinic)

    if (
      inputClinic.clinic_name === "" ||
      inputClinic.clinic_branch === "" ||
      inputClinic.clinic_telp === "" ||
      inputClinic.clinic_address === "" ||
      inputClinic.clinic_email.length < 1
    ) {
      return setErrInput(true);
    }

    try {
      setIsLoading(true);
      const responSubmit = await CreateMasterClinic(client, paramCreateClinic);
      if (responSubmit.data.createMasterClinic.errMsg === "OK") {
        toast.success("New Clinic Submited", {
          position: toast.POSITION.TOP_RIGHT,
        });
        clearValueInput();
        setIsLoading(false);
        setErrInput(false);
        fetchMasterClinic();
        setModalCreateClinic(false);
      } else {
        toast.error(responSubmit.data.createMasterClinic.errMsg, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setIsLoading(false);
        setErrInput(false);
      }
    } catch (error) {
      alert(error);
    }
  };

  return (
    <React.Fragment>
      <FullScreenLoading
        show={isLoading}
        backdropProps={{ style: { zIndex: 10000 } }}
      />
      <ToastContainer />
      <Button startIcon={<Icon>add_circle</Icon>} variant="contained" onClick={handleOpenModalCreateClinic}>
        Add Clinic
      </Button>
      <Dialog open={modalCreateClinic} onClose={handleCloseModalCreateClinic} fullWidth maxWidth="sm" >
        <DialogTitle>Add New Clinic</DialogTitle>
        <DialogContent>
          <div className="form-row mb-1">
            <div className="col-md-12">
              <FormGroup
                isRequired
                placement="vertical"
                errorMessage={
                  <p style={{ fontSize: 13 }}>Clinic Name is required</p>
                }
                isError={errInput && !inputClinic.clinic_name}
                showChildErrorSign
              >
                <label htmlFor="" style={{ fontSize: 12 }}>
                  Clinic Name
                </label>
                <Input
                  type="text"
                  onChange={(e) =>
                    setInputClinic({
                      ...inputClinic,
                      clinic_name: e.target.value,
                    })
                  }
                />
              </FormGroup>
            </div>
          </div>
          <div className="form-row mb-1">
            <div className="col-md-6">
              <FormGroup
                isRequired
                placement="vertical"
                errorMessage={
                  <p style={{ fontSize: 13 }}>Clinic Branch is required</p>
                }
                isError={errInput && !inputClinic.clinic_branch}
                showChildErrorSign
              >
                <label htmlFor="" style={{ fontSize: 12 }}>
                  Branch Name
                </label>
                <Input
                  type="text"
                  onChange={(e) =>
                    setInputClinic({
                      ...inputClinic,
                      clinic_branch: e.target.value,
                    })
                  }
                />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup
                isRequired
                placement="vertical"
                errorMessage={
                  <p style={{ fontSize: 13 }}>No Telp is required</p>
                }
                isError={errInput && !inputClinic.clinic_telp}
                showChildErrorSign
              >
                <label htmlFor="" style={{ fontSize: 12 }}>
                  No telp
                </label>
                <Input
                  type="text"
                  onChange={(e) =>
                    setInputClinic({
                      ...inputClinic,
                      clinic_telp: e.target.value,
                    })
                  }
                />
              </FormGroup>
            </div>
          </div>
          <div className="form-row mb-1">
            <div className="col-md-12">
              <FormGroup
                isRequired
                placement="vertical"
                errorMessage={
                  <p style={{ fontSize: 13 }}>Clinic Email is required</p>
                }
                isError={errInput && !inputClinic.clinic_email.length}
                showChildErrorSign
              >
                <label htmlFor="" style={{ fontSize: 12 }}>
                  Clinic Email
                  <small> (Enter to multiple email)</small>
                </label>
                <div style={{ fontSize: "13px" }}>
                  <TagsInput
                    onChange={(e) => setInputClinic({ ...inputClinic, clinic_email: e })}
                  />
                </div>
              </FormGroup>
            </div>
          </div>
          {/* <div className="form-row mb-1">
            <div className="col-md-12">
              <FormGroup
                isRequired
                placement="vertical"
                errorMessage={
                  <p style={{ fontSize: 13 }}>Clinic Email is required</p>
                }
                isError={errInput && !inputClinic.clinic_branch}
                showChildErrorSign
              >
                <label htmlFor="" style={{ fontSize: 12 }}>
                  Clinic Email
                </label>
                <Input
                  type="text"
                  onChange={(e) =>
                    setInputClinic({
                      ...inputClinic,
                      clinic_email: e.target.value,
                    })
                  }
                />
              </FormGroup>
            </div>
          </div> */}
          {/* <div className="form-row mb-1">
            <div className="col-md-12">
              <FormGroup
                isRequired
                placement="vertical"
                errorMessage={
                  <p style={{ fontSize: 13 }}>No Telp is required</p>
                }
                isError={errInput && !inputClinic.clinic_telp}
                showChildErrorSign
              >
                <label htmlFor="" style={{ fontSize: 12 }}>
                  No telp
                </label>
                <Input
                  type="text"
                  onChange={(e) =>
                    setInputClinic({
                      ...inputClinic,
                      clinic_telp: e.target.value,
                    })
                  }
                />
              </FormGroup>
            </div>
          </div> */}
          <div className="form-row">
            <div className="col-md-12">
              <FormGroup
                isRequired
                placement="vertical"
                errorMessage={
                  <p style={{ fontSize: 13 }}>Clinic Address is required</p>
                }
                isError={errInput && !inputClinic.clinic_address}
                showChildErrorSign
              >
                <label htmlFor="" style={{ fontSize: 12 }}>
                  Address
                </label>
                <Input
                  type="text"
                  multiline
                  onChange={(e) =>
                    setInputClinic({
                      ...inputClinic,
                      clinic_address: e.target.value,
                    })
                  }
                />
              </FormGroup>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="error" onClick={handleCloseModalCreateClinic}>
            Cancel
          </Button>
          <Button variant="contained" onClick={submitClinic}>Submit</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default ModalCreateClinic;
